import type { LocationGroup } from '@/types';

export const EMPTY_TEARSHEET_LOCATION: LocationGroup[] = [
  { continent: '', country: '', state: '', city: '' },
];

export function geoFromLocation(rows: LocationGroup[]): { country?: string; state?: string } {
  const row = rows[0];
  const country = row?.country?.trim();
  const state = row?.state?.trim();
  return {
    ...(country ? { country } : {}),
    ...(state ? { state } : {}),
  };
}
